// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Rk-z","tupacHeader":"Sk-z","tupacHeader2":"Tk-z","tupacMenu":"Uk-z","tupacMenu2":"Vk-z","tupacMain":"Wk-z","tupacMain2":"Xk-z"};